import { Group, Text, Box, Badge } from '@mantine/core'

interface PostureStripProps {
  criticalCount: number
  openCount: number
  /** Dica de interação (ex.: clique numa categoria filtra a fila). */
  hint?: string
}

/**
 * Tira de postura: lidera com os números REAIS de findings abertos — crítico em
 * aberto e total. Sem gauge sintético (decisão D1). Borda esquerda vermelha
 * quando há crítico aberto, teal quando não há.
 */
export function PostureStrip({ criticalCount, openCount, hint }: PostureStripProps) {
  const temCritico = criticalCount > 0
  return (
    <Box
      data-testid="posture-strip"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 14,
        flexWrap: 'wrap',
        padding: '12px 18px',
        background: 'var(--mantine-color-body)',
        borderRadius: 'var(--mantine-radius-md)',
        boxShadow: 'var(--ai-shadow-sm, 0 1px 3px rgba(0,0,0,0.08))',
        borderLeft: `4px solid ${temCritico ? '#e03131' : '#098d93'}`,
      }}
    >
      <Group gap={6} align="baseline">
        <Text fw={800} size="1.5rem"
              c={temCritico ? '#e03131' : undefined}
              ff="var(--mantine-font-family-monospace)">
          {criticalCount}
        </Text>
        <Text size="sm" c="dimmed">crítico{criticalCount === 1 ? '' : 's'} em aberto</Text>
      </Group>
      <Text c="dimmed">·</Text>
      <Group gap={6} align="baseline">
        <Text fw={800} size="1.5rem" ff="var(--mantine-font-family-monospace)">{openCount}</Text>
        <Text size="sm" c="dimmed">finding{openCount === 1 ? '' : 's'} em aberto</Text>
      </Group>
      <Badge color="teal" variant="light" radius="xl" size="sm" tt="none" fw={600}>
        deduplicado por recurso
      </Badge>
      {hint && <Text size="xs" c="dimmed" ml="auto">{hint}</Text>}
    </Box>
  )
}
